import React from 'react';
import MapBox from '../../../shared/mapbox/index';
import _filter from 'lodash/filter';


const MapView = (props) => {


  const sectorWithCoordinates = (props) =>{
    for(var j = 0; j < props.sectors.length; j++){
      props.sectors[j].long = _filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].long;
      props.sectors[j].lat = _filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].lat;
    }
    return props.sectors;
  }

  return (
    <div className="map-view">
      <div className="row">
        <div className="column small-12">
          <MapBox countriesShow={sectorWithCoordinates(props.itineraries)} clickable={true} id={'intineraryMapview'} />
        </div>
      </div>
    </div>
  )
}

export default MapView;



// WEBPACK FOOTER //
// ./src/components/itinerary/details/components/map-view.js